import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import {
  FormGroup, FormControlLabel, Checkbox, Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import axiosInstance from "../../../../lib/axios";
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";
import Autocomplete from "@mui/material/Autocomplete";

// Define columns for the print table
const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "ItmGrpName", label: "Group Name", minWidth: 100 },
  { id: "ItmGrpAbrv", label: "Abbreviation", minWidth: 50 },
  { id: "ItmCatId", label: "Category ID", minWidth: 50 },
  { id: "Remark", label: "Remark", minWidth: 100 },
  { id: "Status", label: "Status", minWidth: 50 },
];

const ReipeGrp = () => {
  const { register, setValue, reset, watch, getValues } = useForm({
    defaultValues: {
      ItmGrpName: "",
      ItmGrpAbrv: "",
      ItmCatId: "",
      Remark: "",
      Status: "1",
    },
  });

  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const [ItmGrpId, setItmGrpId] = useState(-1);
  const [Mode, setMode] = useState("add");
  const [TransactionData, setTransactionData] = useState([]);
  const [CategoryDrp, setCategoryDrp] = useState([]);
  const [transformedCategoryDrp, setTransformedCategoryDrp] = useState([]);
  const [OpenDForDelete, setOpenDForDelete] = useState(false);
  const [AllDisUnable, setAllDisUnable] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const contentRef = useRef(null);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const handlePrint = useReactToPrint({ contentRef });

  // Transform CategoryDrp for Autocomplete
  useEffect(() => {
    if (CategoryDrp.length > 0) {
      const transformed = CategoryDrp.map((item) => ({
        Id: item.ItmCatId,
        Name: item.ItmCatName,
      }));
      setTransformedCategoryDrp(transformed);
    }
  }, [CategoryDrp]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchPropertyData();
      await fetchDashboardData();

      if (location.state) {
        setAllDisUnable(false);
        let ItmGrpId = location.state.ItmGrpId;
        setItmGrpId(ItmGrpId);
        await fetchTransactionData(ItmGrpId, "R");
      } else {
        setMode("add");
        setAllDisUnable(true);
        resetFunc();
      }
    };

    fetchData();
  }, [location.state]);

  useEffect(() => {
    if (TransactionData.length > 0 && Mode !== "add") {
      const obj = TransactionData[0];
      setValue("ItmGrpName", obj.ItmGrpName || "");
      setValue("ItmGrpAbrv", obj.ItmGrpAbrv || "");
      setValue("ItmCatId", obj.ItmCatId || "");
      setValue("Remark", obj.Remark || "");
      setValue("Status", obj.Status || "1");
      setAllDisUnable(false);
    }
  }, [TransactionData, Mode, setValue, getValues]);

  const fetchDashboardData = async () => {
    try {
      const res = await axiosInstance.post("MstItmGrp/GetMstItmGrpDashBoard", {
        start: 4,
        PageSize: 0,
        SearchText: "",
        Flag: "F"
      });
      if (res.data && res.data.Data) {
        setRows(res.data.Data);
        setDataForPrint(res.data.Data);
      } else {
        setRows([]);
        setDataForPrint({});
      }
    } catch (err) {
      toast.error("Error fetching dashboard data");
    }
  };

  const fetchPropertyData = async () => {
    try {
      const response = await axiosInstance.post(
        `MstItmCat/GetMstItmCatDashBoard`,
        {
          start: 1,
          PageSize: 1,
          SearchText: "",
          Flag: 'Food'
        }
      );

      if (response.data.Status === 0) {
        setCategoryDrp(response.data.Data);
      } else {
        toast.error("Error fetching Category data");
      }
    } catch (error) {
      toast.error("Error fetching property data");
    }
  };

  const fetchTransactionData = async (ItmGrpId, Flag) => {
    try {
      const response = await axiosInstance.post(`MstItmGrp/RetriveMstItmGrp`, {
        ItmGrpId,
        Flag,
      });

      if (response.data.Status === 0) {
        if (Flag === "D") {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(ItmGrpId, "L");
          return;
        }
        let Data = response.data.Data != null ? response.data.Data : [];
        setTransactionData(Data);
        setItmGrpId(response.data.Data[0].ItmGrpId);
        setMode("view");
      } else {
        if (Flag !== "D") {
          setItmGrpId(-1);
          setMode("add");
          resetFunc();
        }
        toast.info(response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching Transaction data:", error);
    }
  };

  const handleAddClick = () => {
    setMode("add");
    setAllDisUnable(true);
    resetFunc();
  };

  const handleEditClick = async () => {
    let Flag = await checkAndLock(ItmGrpId, "MstItmGrp", "ItmGrpId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setAllDisUnable(true);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleCancelDButton = () => {
    setOpenDForDelete(false);
  };

  const handleSubmitClick = async () => {
    const Obj = getValues();
    if (!Obj.ItmGrpName || !Obj.ItmCatId) {
      toast.info("Please Fill Required Field!");
      return;
    }

    let Payload = {
      ItmGrpName: Obj.ItmGrpName,
      ItmGrpAbrv: Obj.ItmGrpAbrv,
      ItmCatId: Obj.ItmCatId,
      Remark: Obj.Remark,
      Status: Obj.Status,
      CreatedBy: parseInt(UserId),
    };

    if (Mode === "add") {
      try {
        const response = await axiosInstance.post(`MstItmGrp/InsertMstItmGrp`,
          Payload
        );

        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(1, "L");
          setMode("view");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        console.error("Error inserting data:", error);
      }
    } else {
      Payload = { ...Payload, ItmGrpId, UpdatedBy: parseInt(UserId) };
      delete Payload.CreatedBy;

      try {
        const response = await axiosInstance.post(
          `MstItmGrp/UpdateMstItmGrp`,
          Payload
        );

        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          await UnLock(ItmGrpId, "MstItmGrp", "ItmGrpId");
          fetchTransactionData(ItmGrpId, "R");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        console.error("Error updating data:", error);
      }
    }
  };

  const handleCancelClick = async () => {
    if (ItmGrpId === -1 && Mode === "add") {
      await fetchTransactionData(1, "L");
    } else {
      await UnLock(ItmGrpId, "MstItmGrp", "ItmGrpId");
      await fetchTransactionData(ItmGrpId, "R");
    }
  };

  const handleCategoryChange = (event, newValue) => {
    const selectedId = newValue ? newValue.Id : "";
    setValue("ItmCatId", selectedId, { shouldValidate: true });
  };

  const handleDeleteClick = () => {
    setOpenDForDelete(true);
  };

  const handleClickBackToTable = () => {
    navigate("/recipe-table");
  };

  const handleConfirmDDelete = () => {
    fetchTransactionData(ItmGrpId, "D");
    setOpenDForDelete(false);
  };

  const handleNextClick = () => {
    fetchTransactionData(ItmGrpId, "N");
  };

  const handlePrevClick = () => {
    fetchTransactionData(ItmGrpId, "P");
  };

  const resetFunc = () => {
    reset({
      ItmGrpName: "",
      ItmGrpAbrv: "",
      ItmCatId: "",
      Remark: "",
      Status: "1",
    });
  };

  const handleCheckBoxChange = () => {
    setValue("Status", watch("Status") === "1" ? "0" : "1", { shouldValidate: true });
  };

  return (
    <Box className="form-container" sx={{ height: { xs: "700px", sm: "550px" } }}>
      <Dialog
        open={OpenDForDelete}
        onClose={handleCancelDButton}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Do You Want To Delete The Unit ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCancelDButton}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
      <Grid container spacing={2} className="form_grid">
        <Grid
          item
          xs={12}
          className="form_title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "20px",
            flexDirection: { xs: "column", sm: "row", md: "row" },
          }}
        >
          <Grid
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-start" },
              marginBottom: { xs: "10px", sm: 0 },
            }}
          >
            <Button
              variant="contained"
              size="small"
              className="three-d-button-previous"
              sx={{
                backgroundColor: "#635BFF",
                marginRight: { xs: "5px", sm: "10px" },
                display: { xs: "none", sm: "block" },
              }}
              onClick={handlePrevClick}
              disabled={AllDisUnable}
            >
              <KeyboardArrowLeftIcon />
            </Button>

            <Button
              variant="contained"
              size="small"
              className="three-d-button-next"
              sx={{
                backgroundColor: "#635BFF",
                display: { xs: "none", sm: "block" },
              }}
              onClick={handleNextClick}
              disabled={AllDisUnable}
            >
              <NavigateNextIcon />
            </Button>
          </Grid>

          <Typography
            variant="h5"
            sx={{
              margin: "Auto",
              textAlign: { xs: "center", sm: "center" },
              fontSize: { xs: "24px", sm: "18px", md: "24px" },
            }}
          >
            Recipe Group Master
          </Typography>

          <Grid sx={{ display: "flex", justifyContent: "end" }}>
            <CrudButtons
              moduleName="Recipe Group"
              mode={Mode}
              onAdd={handleAddClick}
              onEdit={handleEditClick}
              onView={handlePrint}
              onDelete={handleDeleteClick}
              onExit={handleClickBackToTable}
              readOnlyMode={!AllDisUnable}
              onPrevious={handlePrevClick}
              onNext={handleNextClick}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={10} className="form_field" sx={{ marginX: "auto" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={5}>
              <Autocomplete
                options={transformedCategoryDrp}
                getOptionLabel={(option) => option.Name || ""}
                value={
                  transformedCategoryDrp.find(
                    (option) => option.Id === watch("ItmCatId")
                  ) || null
                }
                onChange={handleCategoryChange}
                disabled={!AllDisUnable}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Category List <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                  />
                )}
                noOptionsText="No categories available"
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                id="ItmGrpName"
                name="ItmGrpName"
                label={
                  <span>
                    Group Name <span style={{ color: "red" }}>*</span>
                  </span>
                }
                value={watch("ItmGrpName") || ""}
                {...register("ItmGrpName")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>

            <Grid item xs={12} md={5}>
              <TextField
                id="ItmGrpAbrv"
                name="ItmGrpAbrv"
                label="Abbreviation"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch("ItmGrpAbrv") || ""}
                {...register("ItmGrpAbrv")}
                disabled={!AllDisUnable}
              />
            </Grid>

            <Grid item xs={12} md={5}>
              <TextField
                id="Remark"
                name="Remark"
                label="Remark"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch("Remark") || ""}
                {...register("Remark")}
                disabled={!AllDisUnable}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!AllDisUnable}
                      name="Status"
                      checked={watch("Status") === "1"}
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Status"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className="form_button">
          <Button
            variant="contained"
            sx={{
              mr: 1,
              background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
            }}
            onClick={handleSubmitClick}
            disabled={!AllDisUnable}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            sx={{
              mr: 1,
              background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
            }}
            onClick={handleCancelClick}
            disabled={!AllDisUnable}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>

      {/* Hidden Print Section */}
      <div style={{ display: "none" }}>
        {Object.keys(DataForPrint).length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Group Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
    </Box>
  );
};

export default ReipeGrp;